// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card[data-v-3b60ac3c]{border:1px solid #d3d3d3}.card-content[data-v-3b60ac3c]{max-height:200px;padding:.5rem;overflow:auto}.add-to-cart[data-v-3b60ac3c]{margin-bottom:.5rem}.part-info[data-v-3b60ac3c]{padding-bottom:1rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
